/**
 * MapPin Component
 *
 * A styled marker component using a pin image.
 * Migrated from recompose to React hooks.
 *
 * Note: The default pin image path is app-specific.
 * Override via the 'image' prop for custom pins.
 */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import Marker from './Marker';

/**
 * Default pin image path
 * This can be overridden by passing an 'image' prop
 */
const DEFAULT_PIN_IMAGE = 'assets/images/map/maps-pin-blue.png';

function MapPin({ google, map, image, location }) {
	// Memoize the icon to prevent recreation on each render
	const icon = useMemo(() => {
		// Guard against undefined google object during SSR or initial render
		if (!google?.maps) {
			return undefined;
		}

		return new google.maps.MarkerImage(
			image || DEFAULT_PIN_IMAGE,
			new google.maps.Size(30, 42),
			new google.maps.Point(0, 0),
			new google.maps.Point(15, 42),
		);
	}, [google, image]);

	return (
		<Marker
			google={google}
			map={map}
			icon={icon}
			location={location}
		/>
	);
}

MapPin.propTypes = {
	google: PropTypes.object,
	map: PropTypes.object,
	image: PropTypes.string,
	location: PropTypes.shape({
		latitude: PropTypes.number.isRequired,
		longitude: PropTypes.number.isRequired,
	}).isRequired,
};

export default MapPin;
